import React from 'react';
import type { FC } from 'react';
import { match } from 'variant';
import { Alert, Spinner, useAsync } from '@wix/cli-ui-kit';
import { useBackendAsAServiceClient } from '@wix/backend-as-a-service-client';
import { useProjectModel } from '../../model.js';

const ENV_NAME = 'prod';

export const EnvRemove: FC<{ variableKey: string }> = ({ variableKey }) => {
  const { model } = useProjectModel();
  const backendAsAServiceClient = useBackendAsAServiceClient();

  const { status } = useAsync(async () => {
    await backendAsAServiceClient.deleteAppEnvironmentVariable(
      model.config.appId,
      ENV_NAME,
      variableKey
    );
  }, []);

  return match(status, {
    Loading: () => <Spinner text="Removing environment variable..." />,
    Success: () => (
      <Alert type="success">
        "{variableKey}" was successfully removed from "{ENV_NAME}" environment.
        Note: This only removes the variable from the remote environment. It
        won't delete it from .env.local.
      </Alert>
    ),
    Error: () => null,
    NotRequested: () => null,
  });
};
